import { BitrixVue } from "ui.vue";

BitrixVue.component("SimpleItemTop", {
	props: ["state", "image", "title"],
	template: `
    <div class="config-slider__item" @click="$emit('setActive')">
        <div class="config-slider__item-top">
            <div class="config-slider__img">
                <div class="config-slider__selection"></div>
                <img :src="this.image" :alt="this.title">
            </div>
            <div v-if="this.title" class="config-slider__title">{{this.title}}</div>
        </div>
    </div>
`,
});
